<template>
    <div>
        <!-- banner 头部 BEGIN -->
        <a-row class="bg-img" type="flex" justify="center" align="middle" >
            <a-col :span="22">
                <a-row type="flex" justify="center" align="bottom">
                    <a-col :xs="12" :sm="12" :md="6" :lg="4" :xl="4">
                        <div class="enter-flex">
                            <div style="padding: 20px 20px 0 20px"><a-icon type="shop" style="font-size: 40px;" /></div>
                            <div style="padding-top: 20px;">
                                <div class="enter-24">200+</div>
                                <div class="enter-16">优秀商家覆盖</div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :xs="12" :sm="12" :md="6" :lg="5" :xl="5">
                        <div class="enter-flex">
                            <div style="padding: 20px 20px 0 20px"><a-icon type="clock-circle" style="font-size: 40px;" /></div>
                            <div style="padding-top: 20px;">
                                <div class="enter-24">信息可靠</div>
                                <div class="enter-16">专业审核信息有保障</div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :xs="12" :sm="12" :md="6" :lg="5" :xl="5">
                        <div class="enter-flex">
                            <div style="padding: 20px 20px 0 20px"><a-icon type="api" style="font-size: 40px;" /></div>
                            <div style="padding-top: 20px;">
                                <div class="enter-24">精准对接</div>
                                <div class="enter-16">一键匹配供需信息</div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :xs="12" :sm="12" :md="6" :lg="5" :xl="5">
                        <div class="enter-flex">
                            <div style="padding: 20px 20px 0 20px "><a-icon type="safety"style="font-size: 40px;" /></div>
                            <div style="padding-top: 20px;">
                                <div class="enter-24">48小时</div>
                                <div class="enter-16">平均48小时找到满意商家</div>
                            </div>
                        </div>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="22">         
                <div class="banner-text">
                    <img src="@/assets/kh.png" class="text-img" width="70%">
                </div>
            </a-col>
            <a-col :span="22" class="center">
                <img src="@/assets/an2.svg" width="30%" class="img-demand" @click="toRouterPage()">
                <img src="@/assets/an1.svg" width="30%" class="img-enterprise" @click="toRouterPage()">
            </a-col>
        </a-row>
        <!-- banner 头部 END -->
        <!-- 内容 BEGIN -->
        <!-- 平台简介 BEGIN -->
        <a-card :bordered="false" class="top-20 no-background">          
            <a-row type="flex" justify="center" align="middle" >            
                <!-- <a-col :span="22" class="tb-20"> 
                    <a-divider >
                        <div style="color:#4F4F4F;font-size: 28px;letter-spacing:2px;">平台简介</div>
                        <div class="gray-color" >PLATFORM INTRODUCTIONL</div>
                    </a-divider>
                    <div class="center top-10">
                        <img src="@/assets/4L2.png" width="75%" >
                    </div>                    
                </a-col> -->
                <a-col :span="22" class="top-20"> 
                    <a-row type="flex" justify="center" :gutter="16">
                        <a-col :xs="12" :sm="8" :md="8" :lg="4" :xl="4">                           
                            <div class="square" @click="toRoute('EnterpriseCenter')">
                                <img src="@/assets/l1.png" class="square-image top-20" >
                                <div class="square-text">{{enterpriseCount}}<a class="square-text-line">&nbsp;家</a></div>
                                <div class="square-text-two">入驻服务商</div>
                            </div>                         
                        </a-col>
                        <a-col :xs="12" :sm="8" :md="8" :lg="4" :xl="4">                           
                            <div class="square" @click="toRoute('searchDemand')">
                                <img src="@/assets/l2.png" class="square-image top-20" >
                                <div class="square-text">{{demandCount}}<a class="square-text-line">&nbsp;个</a></div>
                                <div class="square-text-two">发布需求数</div>
                            </div>                         
                        </a-col>
                        <a-col :xs="12" :sm="8" :md="8" :lg="4" :xl="4">                           
                            <div class="square" @click="toRoute('EnterpriseCenter')">
                                <img src="@/assets/l5.png" class="square-image top-20" >
                                <div class="square-text">{{serviceCount}}<a class="square-text-line">&nbsp;件</a></div>
                                <div class="square-text-two">可提供服务</div>
                            </div>                         
                        </a-col>
                        <a-col :xs="12" :sm="8" :md="8" :lg="4" :xl="4">                           
                            <div class="square" @click="toRoute('ProductCenter')">
                                <img src="@/assets/l6.png" class="square-image top-20" >
                                <div class="square-text">{{productCount}}<a class="square-text-line">&nbsp;个</a></div>
                                <div class="square-text-two">已发布产品</div>
                            </div>                         
                        </a-col>
                        <a-col :xs="12" :sm="8" :md="8" :lg="4" :xl="4">                           
                            <div class="square" @click="toRoute('SpecialtyCenter')">
                                <img src="@/assets/l4.png" class="square-image top-20" >
                                <div class="square-text">{{caseSum }}<a class="square-text-line">&nbsp;万元</a></div>
                                <div class="square-text-two">总成交金额</div>
                            </div>                         
                        </a-col>
                        <a-col :xs="12" :sm="8" :md="8" :lg="4" :xl="4">                           
                            <div class="square" @click="toRoute('SpecialtyCenter')">
                                <img src="@/assets/l3.png" class="square-image top-20" >
                                <div class="square-text">{{ caseCount }}<a class="square-text-line">&nbsp;件</a></div>
                                <div class="square-text-two">已完成交易</div>
                            </div>                         
                        </a-col>
                    </a-row>
                </a-col>
           </a-row>                       
        </a-card>
        <!-- 平台简介 END -->
        <!-- 政策 BEGIN -->
        <a-card :bordered="false" class="top-20">
            <a-row type="flex" justify="center" align="middle">            
                <a-col :span="22" class="tb-20"> 
                    <a-divider >
                        <div style="color:#4F4F4F;font-size: 28px;letter-spacing:2px;">惠企政策</div>
                        <div class="gray-color" >ENTERPRISE FRIENDLY POLICIES</div>
                    </a-divider>                          
                </a-col>
                <a-col :span="22">
                    <div class="news-title">                        
                        <div class="news-item-title">标题</div>
                        <div>发布时间</div>
                    </div>                
                    <div class="news-scroll-container">
                        <div class="news-scroll-content">     
                            <template v-for="(item1,index1) in policies">
                                <div class="news-item" @click="toDetail('policy',item1)" >
                                    <span style="color: #296DE3;margin-right: 10px;">{{item1.type_dictText}}政策</span>
                                    <div class="news-item-title">{{ item1.title }}</div>
                                    <a>{{ item1.releaseDate }}</a>
                                </div> 
                            </template>                                          
                        </div>
                    </div>     
                    <div class="more-info">
                        强政策支撑，创民营经济繁荣盛景，<span style="color: #296DE3" @click="toRoute('searchPolicy')">点击查看更多策略信息...</span>
                    </div>
                </a-col>
            </a-row>
        </a-card>
        <!-- 惠企政策 END -->
        <!-- 产品中心 BEGIN -->
        <a-card :bordered="false" class="no-background">
            <a-row type="flex" justify="center" align="middle">            
                <a-col :span="22" class="tb-20"> 
                    <a-divider >
                        <div style="color:#4F4F4F;font-size: 28px;letter-spacing:2px;">产品中心</div>
                        <div class="gray-color" >PRODUCTS CENTER</div>
                    </a-divider>                     
                </a-col>
                <a-col :span="22"  class="tb-20"> 
                    <a-row type="flex" justify="space-between" :gutter="32">
                        <a-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                            <div class="product-center-left glow-border"> 
                                <LabelTagSelected  @addLabel="addLabel" ></LabelTagSelected> 
                            </div>
                        </a-col>
                        <a-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
                            <div  class="product-center-right">
                                <a-row type="flex" justify="space-between" :gutter="32">
                                    <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="product-center-pic">
                                        <div v-if="products.length>1" class="zoom-effect bg-white">
                                            <a-carousel autoplay  style="height: 120px;">
                                                <div v-for="imgs1 in products[1].imgList"  @click="toDetail('product',products[1])">
                                                    <img :src="getFileAccessHttpUrl(imgs1.filePath)" height="120px" width="100%"/>                                                 
                                                </div>                                                
                                            </a-carousel>
                                            <div class="product-name2">{{products[1].name}}</div>
                                        </div>
                                        <div v-if="products.length>2" class="zoom-effect bg-white">
                                            <a-carousel autoplay style="height: 120px;">
                                                <div v-for="imgs2 in products[2].imgList"  @click="toDetail('product',products[2])">
                                                    <img :src="getFileAccessHttpUrl(imgs2.filePath)" height="120px" width="100%"/>                                      
                                                </div>                                                
                                            </a-carousel>
                                            <div class="product-name2">{{products[2].name}}</div>
                                        </div>
                                        <div v-if="products.length>3" class="zoom-effect bg-white">
                                            <a-carousel autoplay style="height: 120px;">
                                                <div v-for="imgs3 in products[3].imgList"  @click="toDetail('product',products[3])">
                                                    <img :src="getFileAccessHttpUrl(imgs3.filePath)" height="120px" width="100%"/>                                         
                                                </div>                                               
                                            </a-carousel>
                                            <div class="product-name2">{{products[3].name}}</div>
                                        </div>
                                        <div class="zoom-effect" v-if="products.length < 4">
                                            <img height="120px" width="100%"  src="@/assets/img/product-1.png"/>
                                            <div class="product-name2">平台推荐，更多产品</div>
                                        </div>  
                                        <div  class="zoom-effect" v-if="products.length < 3">
                                            <img height="120px" width="100%"  src="@/assets/img/product-2.png"/>
                                            <div class="product-name2">平台推荐，更多产品</div>
                                        </div>   
                                        <div  class="zoom-effect" v-if="products.length < 2">
                                            <img height="120px" width="100%"  src="@/assets/img/product-3.png"/>
                                            <div class="product-name2">平台推荐，更多产品</div>
                                        </div>                                   
                                    </a-col>
                                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16" >
                                        <div v-if="products.length>0" class="zoom-effect bg-white">
                                            <a-carousel autoplay  style="height:408px">
                                                <div v-for="imgs0 in products[0].imgList" @click="toDetail('product',products[0])">
                                                    <img :src="getFileAccessHttpUrl(imgs0.filePath)" height="408px" width="100%"/>                                              
                                                </div>                                               
                                            </a-carousel> 
                                            <div class="product-name">{{products[0].name}}</div>                                           
                                        </div>
                                        <div v-else class="zoom-effect" style="width: 100%;">
                                            <img  height="408px" width="100%" src="@/assets/img/product-4.png" @click="toRoute('ProductCenter')"/>
                                            <div  class="product-name ">平台推荐，来源可靠</div>
                                        </div>
                                    </a-col>
                                </a-row>
                            </div>                           
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="22">
                    <div class="more-info">
                        平台严选，产品来源真实可靠，<span style="color: #296DE3" @click="toRoute('ProductCenter')">点击查看更多产品...</span>
                    </div>
                </a-col>
            </a-row>
        </a-card>
        <!-- 产品中心 END -->
        <!-- 服务商库 BEGIN -->
        <a-card :bordered="false" class="top-20">          
            <a-row type="flex" justify="center" align="middle" >            
                <a-col :span="22" class="tb-20"> 
                    <a-divider >
                        <div style="color:#4F4F4F;font-size: 28px;letter-spacing:2px;">服务商库</div>
                        <div class="gray-color" >DATABASE OF SERVICE PROVIDERS</div>
                    </a-divider> 
                    <template v-if="enterprises.length>0">
                        <a-carousel dot-position="top"  arrows dots-class="slick-dots slick-thumb" style="padding-top: 20px;">    
                            <a slot="customPaging" slot-scope="props">                
                                <div> {{props.i}}</div>                        
                            </a>                              
                        <div v-for="(item2 ,index2 ) in enterprises" :key="index2">
                            <a-row type="flex" justify="space-between" :gutter="64">
                                <template v-for="(en , i ) in item2">
                                    <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="top-10">   
                                                                         
                                        <a-card :bodyStyle="{padding: 0}" hoverable>  
                                            <div style="position: absolute;right: 0;">
                                                <img src="@/assets/yz.svg" width="75px;" > 
                                            </div>                            
                                            <a-row style="padding: 20px;" type="flex" justify="space-between" align="middle">
                                                <a-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">  
                                                    <template v-if="en.logo">
                                                        <img :src="getFileAccessHttpUrl(en.logo)" width="130px;" height="130px;" style="margin-right: 20px;"/>                        
                                                    </template>
                                                    <template v-else>
                                                        <img src="@/assets/no-logo.png" width="130px;" height="130px;" style="margin-right: 20px;background: white;"/> 
                                                    </template> 
                                                </a-col>
                                                <a-col :xs="24" :sm="24" :md="24" :lg="18" :xl="18">  
                                                    <div style="width: 100%;">
                                                        <div class="flex-between">
                                                            <div class="flex-between">
                                                                <div class="enter-18 bold">{{en.name}} </div>
                                                                <div class="enter-12 line-1" style="margin-left: 10px;"> 
                                                                    <div><a-icon type="idcard" style="color: #40a9ff;" /></div>                                                         
                                                                    <a-rate :value="en.level" disabled style="font-size: 12px"/>
                                                                </div>
                                                            </div>
                                                            <!-- <div>                                                                                                        
                                                                <a-tag v-if="en.ifFine=='1'" color="#87d068" style="line-height: 2;">优质</a-tag>   
                                                                <a-tag v-if="en.ifBrand=='1'" color="#fa8c16" style="line-height: 2;">品牌</a-tag>                                         
                                                            </div>  -->
                                                        </div> 
                                                        <div class="enter-14 gray-color line-2">所属行业：
                                                            <span v-for="(tag, index) in en.labelList" :key="tag.id">
                                                            {{ tag.labelName }} <span v-if="index!==(en.labelList.length-1)">|</span>
                                                            </span>
                                                        </div>                                                   
                                                        <div class="enter-14 gray-color line-2 flex-between">
                                                            <div>达成合作： {{en.caseCount}} 件</div>
                                                            <div>共： {{en.collect}} 人收藏</div>
                                                        </div>  
                                                        <div class="enter-14 gray-color line-2">所在区域：{{en.address}}</div>
                                                        <div class="enter-14 gray-color line-2 flex-between">
                                                            <div>公司简介：<span style="color: #296DE3" @click="toDetail('enterprise',en)">查看详情...</span></div>
                                                            <div><a-button type="primary" @click="toDetail('enterprise',en)" >雇他服务</a-button></div>
                                                        </div>
                                                    </div>
                                                </a-col>

                                            </a-row>                                
                                        </a-card>
                                    </a-col>                                
                                </template>
                                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="top-10" v-if="item2.length == 1 || item2.length == 3" >
                                    <a-card :bodyStyle="{padding: 0,background:'#00baad',color:'#fff',height: '100%'}" hoverable style="height: 100%;">
                                        <div style="padding:20px;">
                                            <div class="enter-20 line-2 center">{{item2[item2.length-1].name}}公司简介</div>
                                            <div class="enter-14 ellipsis-multiline top-10 ">{{item2[item2.length-1].content}}</div>
                                        </div>
                                    </a-card>
                                </a-col>
                            </a-row>
                        </div> 

                    </a-carousel>
                    </template> 
                    <template v-else>
                        <div style="text-align: center;">
                            <img class="img" :src="noDataPng" width="160px"/>        
                        </div>
                    </template>
                    
                </a-col>
                <a-col :span="22">
                    <div class="more-info">
                        严格的准入门槛，让客户无忧合作，<span style="color: #296DE3" @click="toRoute('EnterpriseCenter')">点击挑选更多服务商...</span>
                    </div>
                </a-col>
           </a-row>                       
        </a-card>
        <!-- 服务商库 END -->
        <!-- 需求大厅 BEGIN -->
        <a-card :bordered="false" class="top-20 no-background">
            <a-row type="flex" justify="center" align="middle">            
                <a-col :span="22" class="tb-20"> 
                    <a-divider >
                        <div style="color:#4F4F4F;font-size: 28px;letter-spacing:2px;">需求大厅</div>
                        <div class="gray-color" >HALL OF DEMANDS</div>                        
                    </a-divider>   
                    <template v-if="demands.length>0">
                        <a-carousel dot-position="top" arrows dots-class="slick-dots slick-thumb" style="padding-top: 20px;">  
                            <a slot="customPaging" slot-scope="props">                
                                <div> {{props.i}}</div>                        
                            </a>
                            <div  v-for="(item3 ,index3 ) in demands" :key="index3">
                                <a-row type="flex"  :gutter="32">
                                    <template v-for="demand in item3">
                                        <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" class="top-10">                                      
                                            <a-card :bodyStyle="{padding:0,}" hoverable>                    
                                                <div class="square-hall-box">
                                                    <div class="box-header">
                                                        <img src="@/assets/gth.png" width="15px" class="gth-icon" alt="gth icon">
                                                        <div class="text-span">&nbsp;共<span class="red-text">{{demand.involved}}</span>人已参与</div>
                                                        <img src="@/assets/yx.svg" width="60px" class="yx-icon" alt="yx icon">
                                                    </div>
                                                    <div class="box-content">
                                                        <div class="text-span1 line-2">{{demand.name}}</div>
                                                        <div class="text-span2 line-2">需求预算：
                                                            <span v-if="demand.budgetType =='1'">面议</span>
                                                            <span v-else>￥{{demand.budget}}元</span>
                                                        </div>
                                                        <div class="text-span3 ellipsis-multiline">{{ removeTags(demand.content) }}</div>
                                                    </div>
                                                    <div class="box-footer">                                                 
                                                        <a-button type="primary" block  @click="toDetail('demand',demand)">查看详情</a-button>                                                                                                                                                                                         
                                                        <div class="text-span4">发布日期:<span class="red-text">&nbsp;{{getFormatDate(demand.releaseDate)}}</span></div>
                                                    </div>
                                                </div>                        
                                            </a-card>
                                        </a-col>
                                    </template>
                                </a-row>
                            </div>                                         
                        </a-carousel>     
                    </template>
                    <template v-else>
                        <div style="text-align: center;">
                            <img class="img" :src="noDataPng" width="160px"/>        
                        </div>
                    </template>                    
                </a-col>
                <a-col :span="22">
                    <div class="more-info">
                        平台多层筛选，信息真实可靠，<span style="color: #296DE3" @click="toRoute('searchDemand')">点击查看更多需求信息...</span>
                    </div>
                </a-col>
            </a-row>
        </a-card>
        <!-- 需求大厅 END -->
        <!-- 精选案例 BEGIN -->
        <a-card :bordered="false" class="top-20">
            <a-row type="flex" justify="center" align="middle">            
                <a-col :span="22" class="tb-20"> 
                    <a-divider >
                        <div style="color:#4F4F4F;font-size: 28px;letter-spacing:2px;">精选案例</div>
                        <div class="gray-color" >SELECTED CASES</div>                        
                    </a-divider> 
                    <template v-if="cases.length>0">
                    <a-carousel dot-position="top" arrows dots-class="slick-dots slick-thumb" style="padding-top: 20px;">  
                        <a slot="customPaging" slot-scope="props">                
                                <div> {{props.i}}</div>                        
                            </a>                                
                        <div v-for="(item4 ,index4 ) in cases" :key="index4">
                            <a-row type="flex" :gutter="32">
                                <template v-for="tpcase in item4">
                                    <a-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" class="top-10">                                      
                                        <a-card hoverable @click="toDetail('case',tpcase)" class="padding-df" 
                                        :bodyStyle="{padding:'18px 0 0 0'}">
                                            <template v-if="tpcase.fileList.length>0">
                                                <img class="img" slot="cover"  alt="example" style="height: 160px;"
                                                :src="getFileAccessHttpUrl(tpcase.fileList[0].filePath)" />
                                            </template>
                                            <template v-else >
                                                <img class="img" slot="cover"  alt="example"  style="height: 160px;"
                                               src="@/assets/img/product-3.png" />
                                            </template>                                            
                                            <div class="discribe">                                            
                                                <a-row >
                                                    <a-col :span="24"><div class="ellipsis bold">{{tpcase.name}}</div></a-col>
                                                    <a-col :span="24">                                  
                                                        <div class="ellipsis-multiline">{{tpcase.evaluate}}</div>                                                  
                                                    </a-col>
                                                    <a-col :span="24" class="gray-color line-2 top-10">
                                                        <div class="case-ellipsis">服务商户：{{tpcase.benter.name}}</div>
                                                        <div>甲方评分： <a-rate :value="tpcase.score" disabled style="font-size: 14px"/></div>
                                                        <div>成交日期：{{getFormatDate(tpcase.dealDate)}}</div>
                                                    </a-col>
                                                </a-row>                                        
                                            </div>
                                        </a-card>
                                    </a-col>
                                </template>
                            </a-row>
                        </div>  
                    </a-carousel>   
                    </template>  
                    <template v-else>
                        <div style="text-align: center;">
                            <img class="img" :src="noDataPng" width="160px"/>        
                        </div> 
                    </template>
                </a-col>
                <a-col :span="22">
                    <div class="more-info">
                        众多成功案例，让你了解更多服务商<span style="color: #296DE3" @click="toRoute('SpecialtyCenter')">点击查看更多案例...</span>
                    </div>
                </a-col>
            </a-row>
        </a-card>
        <!-- 精选案例 END -->

        <!-- 内容 END -->
        <!-- 用户登录 -->
        <a-modal v-model="showLogin" title="" centered @ok="() => (showLogin = false)" :footer="null">
            <Login></Login>
        </a-modal>
         <!-- 用户登录 -->
    </div> 
</template>

<script>
import Login from '@/views/login/Login.vue';
import { getFileAccessHttpUrl, getAction,httpAction } from '@/api/manage';
import { formatDate } from '@/utils/util';
import noDataPng from '@/assets/no-data.png';
import LabelTagSelected from '@/components/LabelTagSelected.vue';
import Vue from 'vue'
import { ACCESS_TOKEN,USER_INFO } from '@/store/mutation-types'

export default {
    components: {
        Login,LabelTagSelected
    },
    data() {
        return {
           noDataPng:'',
           isLogin:false,
           showLogin: false,
           enterpriseCount:0,
           demandCount:0,
           serviceCount:0,
           productCount:0,
           caseSum:0,
           caseCount:0,
           policies:[],
           enterprises:[],
           demands:[],
           cases:[],  
           products:[],         
           url:{
                queryPlatformTj:'/api/queryPlatformTj',
                queryRecommendPolicyList:'/api/queryRecommendPolicyList',
                queryRecommendEnterList:'/api/queryRecommendEnterList',
                queryRecommendDemandList:'/api/queryRecommendDemandList',
                queryRecommendCaseList:'/api/queryRecommendCaseList',
                queryRecommendProductList:'/api/queryRecommendProductList',
           }
        };
    },
    mounted() {
        this.startAutoScroll();  
    },
    created(){
        this.noDataPng = noDataPng;
        this.queryPlatformTj();
        this.queryRecommendList();
    },
    methods: {
        /**
         * 获取登录状态
         */
        loginStatus(){
            const userInfo = Vue.ls.get(USER_INFO);
            let cur_login;
            if(userInfo){
                this.isLogin = true;
                cur_login = true;
            }else{
                this.isLogin = false;
                cur_login = false;
            }
            return cur_login;
        },
        /**
         * 跳转后端或登录
         */
        toRouterPage(){
            let cur_login =  this.loginStatus();
            if(cur_login){           
                let token = Vue.ls.get(ACCESS_TOKEN)
                // 确保token是URL安全的
                const encodedToken = encodeURIComponent(token);
                // 构建包含token的URL
                const url =  window._CONFIG['casPrefixUrl']+`?token=${encodedToken}`;
                // 打开新页面
                window.location.href = url;    
            }else{
                this.showLogin = true;
            }

        },
        /**
         * 图片路径
         * @param url 
         */
        getFileAccessHttpUrl(url){
            return getFileAccessHttpUrl(url);
        },
        /**
         * 发布日期
         * @param date 
         */
        getFormatDate(date) {
            return formatDate(new Date(date).getTime(), 'yyyy年MM月dd日')
        },
        /**
         * 平台简介 - 各项统计
         */
        queryPlatformTj(){
            const that = this;
            getAction(this.url.queryPlatformTj, null).then((res) => {
                if (res.success) {
                    that.enterpriseCount = res.result.enterpriseCount;
                    that.demandCount = res.result.demandCount;
                    that.serviceCount = res.result.serviceCount;
                    that.productCount = res.result.productCount;
                    that.caseSum = res.result.caseSum;
                    that.caseCount = res.result.caseCount;
                } 
            })
        },
        /**
         * 首页推荐列表
         */
        queryRecommendList(){
            this.queryRecommendPolicyList();
            this.queryRecommendEnterList();
            this.queryRecommendDemandList();
            this.queryRecommendCaseList();
            this.queryRecommendProductList();
        },
        /**
         * 惠企政策
         */
        queryRecommendPolicyList(){
            const that = this;
            getAction(this.url.queryRecommendPolicyList, null).then((res) => {
                if (res.success) {
                    that.policies = res.result;
                } 
            }) 
        },
        /**
         * 惠企政策 - 滚动
         */
        startAutoScroll() {
            const container = document.querySelector('.news-scroll-container');
            const content = document.querySelector('.news-scroll-content');
            let scrollPosition = 0;
            const speed = 1; // 每次滚动的距离
            const interval  = 50; // 每0.5秒滚动一次
            function autoScroll(){
                scrollPosition += speed;
                if (scrollPosition >= content.scrollHeight - container.clientHeight) {
                    scrollPosition = 0; // 回到顶部
                }
                container.scrollTop = scrollPosition;
            }
            var scrollInterval = setInterval(autoScroll,interval);
               // 可选：鼠标悬停暂停
            container.addEventListener('mouseover', () => clearInterval(scrollInterval));
            container.addEventListener('mouseout', () => {
                scrollInterval = setInterval(autoScroll, interval);
            });
        },
        /**
         * 服务商库
         */
        queryRecommendEnterList(){
            const that = this;
            getAction(this.url.queryRecommendEnterList, null).then((res) => {
                if (res.success) {
                    that.enterprises = res.result;
                } 
            })
        },
        /**
         * 需求大厅
         */
        queryRecommendDemandList(){
            const that = this;
            getAction(this.url.queryRecommendDemandList, null).then((res) => {
                if (res.success) {
                    that.demands = res.result;
                    // console.log('--------------------',that.demands.length)
                } 
            })
        },
        /**
         * 精选案例
         */
        queryRecommendCaseList(){
            const that = this;
            getAction(this.url.queryRecommendCaseList, null).then((res) => {
                if (res.success) {
                    that.cases = res.result;
                } 
            })
        },
        /**
         * 产品中心
         */
        queryRecommendProductList(){
            const that = this;
            getAction(this.url.queryRecommendProductList, null).then((res) => {
                if (res.success) {
                    that.products = res.result;
                } 
            })
        },
        /**
         * 跳转详情页面
         * @param record 
         */
        toDetail(type,record) {
            if(type == 'demand'){
                this.$router.push({
                    name: 'showDemand',
                    params: Object.assign({}, this.$route.params, {
                        demandId: record.id
                    })
                })
            }else if(type == 'policy'){
                this.$router.push({
                    name: 'policyDetail',
                    params: Object.assign({}, this.$route.params, {
                        policyId: record.id
                    })
                })
            }else if(type == 'case'){
                this.$router.push({
                    name: 'showCase',
                    params: Object.assign({}, this.$route.params, {
                        caseId: record.id
                    })
                })
            }else if(type == 'enterprise'){
                this.$router.push({
                    name: 'showEnterprise',
                    params: Object.assign({}, this.$route.params, {
                        enterpriseId: record.id
                    })
                })
            }else if(type == 'product'){
                this.$router.push({
                    name: 'showProduct',
                    params: Object.assign({}, this.$route.params, {
                        productId: record.id
                    })
                })
            }
            
        },
        /**
         * 跳转更多页面
         * @param name 
         */
        toRoute(name) {
            this.$router.replace({
                name: name,
            })
        },
        /**
         * 去富文本标签
         * @param str 
         */
        removeTags(str) {
            let doc = new DOMParser().parseFromString(str, 'text/html');
            let content = doc.body.textContent || '';
            content = content.length > 200 ? content.substring(0, 200) + '......' : content
            return content;
        },
      /**
       * 产品中心 - 选择标签
       * @param param 
       */
      addLabel(param) {
        // console.log('---------返回首页--------');
        // console.log(this.param)
        this.$router.replace({
            name: 'ProductCenter',
            params: Object.assign({}, this.$route.params, {
                topId: param.topId,
                managerId : param.managerId,
                labels : param.labels,
                tagsList: param.tagsList
            }),
        })
      },


    },

}

</script>
<style scoped>
.bg-img {
    background-image: url('@/assets/pic1.png');
    background-repeat: round;
    height: auto;
    padding:20px 0;
}
.enter-flex {
    float: left;
    margin-top: 10px;
    display: flex;
    font-weight: 500;
    color: #fff;
}
.banner-text {
    margin: 10px 0;
    text-align: center;
    font-size: 60px;
    color: #4F4F4F;
}
.img-demand{
    height: 100px;
    width: auto;
    margin-right: 10px;
    transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
}
.img-demand:hover{
    height: 100px;
    width: auto;
    transform: scale(1.05);
    cursor: pointer;
}
.img-enterprise{
    margin-left:10px;
    height: 100px;
    width: auto;
    transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
}
.img-enterprise:hover{
    height: 100px;
    width: auto;
    transform: scale(1.05);
    cursor: pointer;
}
.enter-24 {
    font-size: 24px;
}
.enter-20 {
    font-size: 20px;
}
.enter-18 {
    font-size: 18px;
}
.enter-16 {
    font-size: 16px;
}
.enter-14 {
    font-size: 14px;
}
.enter-12 {
    font-size: 12px;
}
.gray-color {
    color: #9a9a9a;
    font-size: 14px;
}
.center{
    text-align: center;
}
.top-10{
    margin-top: 10px;
}
.top-20{
    margin-top: 20px;
}
.tb-20{
    margin:20px 0;
}
.no-background{
    background: none;
}
.bg-white{
    border-color: #fff;
}
.square {
    line-height: 2;
    padding-bottom:20px;
    text-align: center;
    width: 190px;
    background-color: #fff;
    transition: background-color 0.3s, box-shadow 0.3s;  /*添加过渡效果 */
    margin-bottom: 10px;
    display: inline-block;
    overflow: hidden;  /* 防止抖动溢出 */
    border-radius: 10px;
}
.square:hover {
    background: linear-gradient(180deg, rgba(232, 249, 255, 1) 0%, rgba(247, 253, 255, 1) 100%);
    box-shadow: 0 4px 8px #e8e8e8; /* 添加阴影 */
    
}
@keyframes rotate {
  0% { transform: translateY(0px); }
  25% { transform: translateY(5px); }
  50% { transform: translateY(10px) scale(1.1, 0.95);}
  100% {transform: translateY(0px);}
}
.square-image {
    width: 100px; /* 根据需要调整图片大小 */
    height: 100px; /* 根据需要调整图片大小 */
    transition: 0.3s;
}
.square:hover .square-image {
    /* animation: hoverJump 0.8s both;  */
    animation: 0.5s linear 0s 10 normal none running rotate;
}
.square-text {
    font-size: 22px; /* 根据需要调整字体大小 */
    font-weight: bold;
}
.square-text-line {
    font-size: 14px; /* 根据需要调整字体大小 */
    color: #B1B1B1;
    vertical-align: top;
}
.square-text-two {
    font-size: 18px; /* 根据需要调整字体大小 */
    color: #626262;
}
.news-scroll-container {
    width: 100%;
    height: 320px; /* 根据需要调整高度 */
    overflow-y: hidden; /* 垂直滚动 */
    overflow-x: hidden; /* 隐藏水平滚动条 */
    position: relative;
}
.news-scroll-content { 
    padding:10px;
    display: flex;
    flex-direction: column; /* 垂直排列 */ 
}
.news-title{
    margin: 0 10px 10px 10px; /* 根据需要调整间距 */
    background: linear-gradient(180deg, rgba(232, 249, 255, 1) 0%, rgba(247, 253, 255, 1) 100%);
    border: 1px solid rgba(232, 249, 255, 1);
    border-radius: 5px;
    object-fit: cover;
    display: flex; /* 使用 flexbox 布局 */
    justify-content: space-between; /* 确保内容在两端对齐 */
    font-size: 16px;
    line-height: 3;
    padding: 0 20px;
    font-weight: bolder;
}
.news-item {  
    width: 100%;
    margin-bottom: 10px; /* 根据需要调整间距 */
    background: linear-gradient(180deg, rgba(248, 251, 254, 1) 0%, rgba(248, 251, 254, 0) 100%);
    border: 1px solid #dde4eb;
    border-radius: 5px;
    object-fit: cover;
    transition: transform 0.3s ease;  /* 单独控制放大动画 */
    display: flex; /* 使用 flexbox 布局 */
    justify-content: space-between; /* 确保内容在两端对齐 */
    font-size: 16px;
    line-height: 3;
    padding: 0 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.news-item-title {  
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 10px;
}
.news-item a {
    margin-left: auto; /* 将 <a> 标签推到右侧 */
    text-align: right; /* 确保文本内容右对齐 */
    display: block; /* 确保 <a> 标签可以应用 margin-left: auto */
}
.news-item:hover {
    box-shadow: 0 2px 4px #e8e8e8;  /* 鼠标悬停时的阴影 */
    transform: scale(1.01);
}
.more-info {
    margin-top: 20px; /* 根据需要调整间距 */
    text-align: center; /* 文本居中 */
    font-size: 16px; /* 根据需要调整字体大小 */
    color: #8F8F8F; /* 根据需要调整文字颜色 */
}
.more-info-two {
    margin-top: 30px; /* 根据需要调整间距 */
    text-align: center; /* 文本居中 */
    font-size: 16px; /* 根据需要调整字体大小 */
    color: #8F8F8F; /* 根据需要调整文字颜色 */
}
.more-info span {
    color: #296DE3; /* 设置链接文字颜色 */
    cursor: pointer; /* 添加鼠标悬停效果 */
    text-decoration: underline; /* 添加下划线 */
}
.more-info span:hover {
    color: #1a538a; /* 鼠标悬停时的颜色 */
}
.flex-between{
    display: flex;
    justify-content: space-between;
}
.bold{
    font-weight: bold;
}
.line-1{
    line-height: 1;
}
.line-2{
    line-height: 2;
}
.line-3{
    line-height: 3;
}
.square-hall-box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.box-header {
    flex: 2; /* 占据2份高度 */
    display: flex;
    justify-content: space-between;
}
.box-content {
    flex: 4; /* 占据4份高度 */
    margin:0 20px 20px 20px;
    justify-content: center;
}
.box-footer {
    flex: 2; /* 占据2份高度 */
    margin:0 20px 20px 20px;
    text-align: center;
}
.gth-icon {
    width: 15px; /* 根据需要调整图片大小 */
    height: 15px; /* 根据需要调整图片大小 */
    margin-left: 15px;
    align-items: center;
    margin-top: 15px;
}
.text-span{
    align-self: center;
    font-size: 14px;
}
.text-span1{
    font-size: 20px; /* 根据需要调整字体大小 */
    font-weight: bold;
    text-align: center;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 80px;
}
.text-span2{
    font-size: 18px;
    color: #D43030;
    text-align: center;
}
.text-span3{
    font-size: 14px;
    color: #626262;
}
.text-span4{
    font-size: 14px;
    margin-top: 10px;
}
.text-span:last-child {
    margin-right: 0; /* 最后一个 span 不需要右侧间距 */
}
.red-text {
    color: red; /* 设置文字颜色为红色 */
}
.ellipsis{
    font-size: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom:10px;
}
.ellipsis-multiline {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 84px;
}
.product-center-left {
    width: 100%;
    height: 455px;
    background-color: white;
    overflow-y: auto; /* 允许垂直滚动，但隐藏滚动条 */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;
    /* border: 1px solid #e8e8e8; */
    border-radius: 10px;    
}
.glow-border {
  box-shadow: 0 0 20px rgba(255,255,255,0.3);
}
.product-center-right{
    width: 100%;
    height: 460px;
    /* background-color: white; 
    border: 1px solid #e8e8e8; */
}  
.product-center-pic{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.border{
    border: 1px solid #e8e8e8; 
}
.opacity {
    text-align: center;
    background-color: #000;
    color: #fff;
    opacity: 0.5;
    font-size: 14px;
    line-height: 3;
    position: absolute;
    bottom: 0;
    width: 100%;
}
.product-name{
    width: 100% ;
    text-align: center;
    background-color: #1890ff;
    color: #fff;
    opacity: 0.7;
    font-size: 14px;
    line-height: 3;
    letter-spacing: 2px;
}
.product-name2{
    width: 100% ;
    text-align: center;
    background-color: #1890ff;
    color: #fff;
    opacity: 0.7;
    font-size: 10px;
    line-height: 2;
    letter-spacing: 2px;
}
.zoom-effect {
    transition: transform 0.5s ease; /* 平滑过渡效果 */
}
.zoom-effect:hover {
    transform: scale(1.1); /* 放大到110% */
}
.opacity-pic{
    text-align: center;
    background-color: #000;
    color: #fff;
    opacity: 0.5;
    font-size: 12px;
    line-height: 2;
    position: absolute;
    bottom: 0;
    width: 100%;
}
.padding-df{
    padding:20px;
}
.case-ellipsis{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.discribe{
    /* background-image: url('@/assets/bg-case.png');
    background-repeat: no-repeat; 
    background-size: cover;  */
}
/deep/.ant-carousel .slick-dots-top {
    top: -20px;
}
/deep/.ant-carousel .slick-dots li div {
    width: 10px;
    height: 10px;
    font-size: 10px;
    line-height: 1;
    color: grey;
    background-color: grey;
    border-radius: 50%;
}
/deep/.ant-carousel .slick-dots li.slick-active div{
    width: 10px;
    height: 10px;
    font-size: 10px;
    line-height: 1;
    color: #1890ff;
    background-color: #1890ff;
    border-radius: 50%;
}
</style>
